// extracted by mini-css-extract-plugin
export default {"linkNav":"navigation-link_linkNav__cJPvp","label":"navigation-link_label__BwWde"};